import { postFetchAllAssignees } from "src/api/queries/order-portal-bff";
import { useNotification } from "src/composables/useNotification";

export interface AssigneeData {
  id: string | null;
  name: string | undefined;
}

export function useAssigneeService() {
  const { showError } = useNotification();

  async function fetchAssignees() {
    try {
      const response = await postFetchAllAssignees({}, { limit: 1000, page: 1 });
      return response;
    } catch (error) {
      showError();
      throw error;
    }
  }

  async function searchAssignees(name: string | null = null, page: number = 1, limit: number = 25) {
    try {
      const response = await postFetchAllAssignees({ name }, { limit, page });
      return response;
    } catch (error) {
      showError();
      throw error;
    }
  }

  return {
    fetchAssignees,
    searchAssignees,
  };
}
